import { render, staticRenderFns } from "./resourceStoreUseRecordManageList.vue?vue&type=template&id=b54aa968&scoped=true"
import script from "./resourceStoreUseRecordManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreUseRecordManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreUseRecordManageList.vue?vue&type=style&index=0&id=b54aa968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54aa968",
  null
  
)

export default component.exports